import { DeviceManifest } from '@rapoo/device-sdk'
import { keyboardMacro, retailKeyboardConfig } from './generate/capabilityPresets'
import { esk800KeyboardLightingEffects } from './generate/lightingPresets'

/**
 * ESK800-75RT 设备清单
 **/
const rapooESK80075RT: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESK800-75RT',
  mainControl: 'ESK800-75RT',
  type: 'keyboard',
  version: '1.0.0',
  hardware: {
    vendorId: 11836,
    productId: [22341],
    currentPid: 22341,
    transport: 'HID',
    filters: [
      {
        usagePage: 65440,
        usage: 1,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
    ],
  },
  driver: 'OHID',
  ui: {
    // 使用 image 作为 thumbnail 的回退
    assetsDir: 'manifests/ESK900-75RT',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.ESK900_75RT.Blade_Pink',
          value: '#E54F4F',
          key: 'Blade_Pink',
        },
      ],
      current: 'Blade_Pink',
    },
    // 小图标
    icon: 'Hardware-Wireframe-Keyboard',
    // 是否支持设备概览
    overview: false,
  },
  capabilities: [
    retailKeyboardConfig,
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: esk800KeyboardLightingEffects,
      },
    },
    keyboardMacro,
  ],
  layout: {
    image: 'frame',
    top: 28,
    bottom: 16,
    left: 16,
    right: 16,
    unit: 40,
    keys: [
      [
        {
          key: 0x0029,
          keywords: 'Esc',
        },
        {
          key: 0x003a,
          keywords: 'F1',
          x: 0.25,
        },
        {
          key: 0x003b,
          keywords: 'F2',
        },
        {
          key: 0x003c,
          keywords: 'F3',
        },
        {
          key: 0x003d,
          keywords: 'F4',
        },
        {
          key: 0x003e,
          keywords: 'F5',
          x: 0.25,
        },
        {
          key: 0x003f,
          keywords: 'F6',
        },
        {
          key: 0x0040,
          keywords: 'F7',
        },
        {
          key: 0x0041,
          keywords: 'F8',
        },
        {
          key: 0x0042,
          keywords: 'F9',
          x: 0.25,
        },
        {
          key: 0x0043,
          keywords: 'F10',
        },
        {
          key: 0x0044,
          keywords: 'F11',
        },
        {
          key: 0x0045,
          keywords: 'F12',
        },
      ],
      [
        {
          key: 0x0035,
          keywords: '~_`',
          y: 0.1,
        },
        {
          key: 0x001e,
          keywords: '!_1',
          y: 0.1,
        },
        {
          key: 0x001f,
          keywords: '@_2',
          y: 0.1,
        },
        {
          key: 0x0020,
          keywords: '#_3',
          y: 0.1,
        },
        {
          key: 0x0021,
          keywords: '$_4',
          y: 0.1,
        },
        {
          key: 0x0022,
          keywords: '%_5',
          y: 0.1,
        },
        {
          key: 0x0023,
          keywords: '^_6',
          y: 0.1,
        },
        {
          key: 0x0024,
          keywords: '&_7',
          y: 0.1,
        },
        {
          key: 0x0025,
          keywords: '*_8',
          y: 0.1,
        },
        {
          key: 0x0026,
          keywords: '(_9',
          y: 0.1,
        },
        {
          key: 0x0027,
          keywords: ')_0',
          y: 0.1,
        },
        {
          key: 0x002d,
          keywords: '__-',
          y: 0.1,
        },
        {
          key: 0x002e,
          keywords: '+_=',
          y: 0.1,
        },
        {
          key: 0x002a,
          keywords: 'BackSpace',
          y: 0.1,
          w: 2,
        },
        {
          key: 0x004c,
          keywords: 'Delete',
          y: 0.1,
          x: 0.25,
        },
      ],
      [
        {
          key: 0x002b,
          keywords: 'Tab',
          y: 0.1,
          w: 1.5,
        },
        {
          key: 0x0014,
          keywords: 'Q',
          y: 0.1,
        },
        {
          key: 0x001a,
          keywords: 'W',
          y: 0.1,
        },
        {
          key: 0x0008,
          keywords: 'E',
          y: 0.1,
        },
        {
          key: 0x0015,
          keywords: 'R',
          y: 0.1,
        },
        {
          key: 0x0017,
          keywords: 'T',
          y: 0.1,
        },
        {
          key: 0x001c,
          keywords: 'Y',
          y: 0.1,
        },
        {
          key: 0x0018,
          keywords: 'U',
          y: 0.1,
        },
        {
          key: 0x000c,
          keywords: 'I',
          y: 0.1,
        },
        {
          key: 0x0012,
          keywords: 'O',
          y: 0.1,
        },
        {
          key: 0x0013,
          keywords: 'P',
          y: 0.1,
        },
        {
          key: 0x002f,
          keywords: '{_[',
          y: 0.1,
        },
        {
          key: 0x0030,
          keywords: '}_]',
          y: 0.1,
        },
        {
          key: 0x0031,
          keywords: '|_\\',
          y: 0.1,
          w: 1.5,
        },
        {
          key: 0x004b,
          keywords: 'PgUp',
          y: 0.1,
          x: 0.25,
        },
      ],
      [
        {
          key: 0x0039,
          keywords: 'CapsLock',
          y: 0.1,
          w: 1.75,
        },
        {
          key: 0x0004,
          keywords: 'A',
          y: 0.1,
        },
        {
          key: 0x0016,
          keywords: 'S',
          y: 0.1,
        },
        {
          key: 0x0007,
          keywords: 'D',
          y: 0.1,
        },
        {
          key: 0x0009,
          keywords: 'F',
          y: 0.1,
        },
        {
          key: 0x000a,
          keywords: 'G',
          y: 0.1,
        },
        {
          key: 0x000b,
          keywords: 'H',
          y: 0.1,
        },
        {
          key: 0x000d,
          keywords: 'J',
          y: 0.1,
        },
        {
          key: 0x000e,
          keywords: 'K',
          y: 0.1,
        },
        {
          key: 0x000f,
          keywords: 'L',
          y: 0.1,
        },
        {
          key: 0x0033,
          keywords: ':_;',
          y: 0.1,
        },
        {
          key: 0x0034,
          keywords: '"_\'',
          y: 0.1,
        },
        {
          key: 0x0028,
          keywords: 'Enter',
          y: 0.1,
          w: 2.25,
        },
        {
          key: 0x004e,
          keywords: 'PgDn',
          y: 0.1,
          x: 0.25,
        },
      ],
      [
        {
          key: 0x00e1,
          keywords: 'Shift_L',
          y: 0.1,
          w: 2.25,
        },
        {
          key: 0x001d,
          keywords: 'Z',
          y: 0.1,
        },
        {
          key: 0x001b,
          keywords: 'X',
          y: 0.1,
        },
        {
          key: 0x0006,
          keywords: 'C',
          y: 0.1,
        },
        {
          key: 0x0019,
          keywords: 'V',
          y: 0.1,
        },
        {
          key: 0x0005,
          keywords: 'B',
          y: 0.1,
        },
        {
          key: 0x0011,
          keywords: 'N',
          y: 0.1,
        },
        {
          key: 0x0010,
          keywords: 'M',
          y: 0.1,
        },
        {
          key: 0x0036,
          keywords: '<_,',
          y: 0.1,
        },
        {
          key: 0x0037,
          keywords: '>_.',
          y: 0.1,
        },
        {
          key: 0x0038,
          keywords: '?_/',
          y: 0.1,
        },
        {
          key: 0x00e5,
          keywords: 'Shift_R',
          y: 0.1,
          w: 1.75,
        },
        {
          key: 0x0052,
          keywords: '↑',
          y: 0.1,
        },
      ],
      [
        {
          key: 0x00e0,
          keywords: 'Ctrl_L',
          y: 0.1,
          w: 1.25,
        },
        {
          key: 0x00e3,
          keywords: 'Win_L',
          y: 0.1,
          w: 1.25,
        },
        {
          key: 0x00e2,
          keywords: 'Alt_L',
          y: 0.1,
          w: 1.25,
        },
        {
          key: 0x002c,
          keywords: 'Space_L',
          y: 0.1,
          w: 6.25,
        },
        {
          key: 0xf001,
          keywords: 'Fn',
          y: 0.1,
          w: 1.25,
        },
        {
          key: 0x00e4,
          keywords: 'Ctrl_R',
          y: 0.1,
          w: 1.25,
        },
        {
          key: 0x0050,
          keywords: '←',
          y: 0.1,
          x: 0.5,
        },
        {
          key: 0x0051,
          keywords: '↓',
          y: 0.1,
        },
        {
          key: 0x004f,
          keywords: '→',
          y: 0.1,
        },
      ],
    ],
  },
}

export default rapooESK80075RT
